<!--

 -->

<template>
  <div class="gsl-hrm-background-container">
    <div class="gsl-hrm-card-container">
      <oxd-text tag="h6" class="gsl-hrm-main-title">
        {{ $t('time.add_project') }}
      </oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              v-model="project.name"
              :label="$t('general.name')"
              :rules="rules.name"
              required
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <customer-autocomplete
              :key="project.customer"
              v-model="project.customer"
              :rules="rules.customer"
              :label="$t('time.customer_name')"
              required
            />
            <oxd-button
              icon-name="plus"
              display-type="text"
              class="gsl-hrm-input-field-bottom-space"
              :label="$t('time.add_customer')"
              @click="onClickAddCustomer"
            />
          </oxd-grid-item>
        </oxd-grid>
        <oxd-form-row>
          <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.description"
                type="textarea"
                :label="$t('general.description')"
                :rules="rules.description"
                :placeholder="$t('general.type_description_here')"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <project-admin-autocomplete
                v-for="(projectAdmin, index) in projectAdmins"
                :key="index"
                v-model="projectAdmin.value"
                :show-delete="index > 0"
                :rules="rules.projectAdmin"
                include-employees="onlyCurrent"
                @remove="onRemoveAdmin(index)"
              />
              <oxd-button
                v-if="projectAdmins.length < 5"
                icon-name="plus"
                display-type="text"
                :label="$t('general.add_another')"
                @click="onAddAnother"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
                <oxd-grid-item>
                  <div class="gsl-hrm-sm-field">
                    <oxd-text tag="p" class="gsl-hrm-sm-field-label">
                      {{ $t('general.status') }}
                    </oxd-text>
                    <oxd-switch-input v-model="project.status" />
                  </div> </oxd-grid-item
              ></oxd-grid>
            </oxd-grid-item>

            <oxd-grid-item>
              <employee-autocomplete
                v-model="project.accountManager"
                :rules="rules.accountManager"
                :label="$t('general.account_manager')"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.attendanceRequired"
                type="checkbox"
                value="true"
                :true-value="true"
                :false-value="false"
                option-label="Do you need attendance of this Project to validate Timesheet"
                :label="$t('general.attendance')"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.agreementSigned"
                type="checkbox"
                value="true"
                :true-value="true"
                :false-value="false"
                option-label="Is this Project has Signed Agreement"
                :label="$t('general.agreement')"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-form-row>
          <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.budgetRequired"
                type="checkbox"
                value="true"
                :true-value="true"
                :false-value="false"
                option-label="Configure the Budget for this project"
                :label="$t('general.project_budget')"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-text tag="h6" class="gsl-hrm-main-title">
          {{ $t('general.duration') }}
        </oxd-text>
        <oxd-divider />
        <oxd-form-row>
          <oxd-grid :cols="3" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <date-input
                v-model="project.fromDate"
                :label="$t('general.from_date')"
                :rules="rules.fromDate"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <date-input
                v-model="project.toDate"
                :label="$t('general.to_date')"
                :rules="rules.toDate"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-text tag="span" class="gsl-hrm-sub-title">
            Total duration: {{ totalDuration || 0 }} days
          </oxd-text>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-text tag="span" class="gsl-hrm-sub-title">
            Total working day: {{ totalWorkingDays || 0 }} days
          </oxd-text>
        </oxd-form-row>

        <br />

        <oxd-divider />
        <oxd-form-row>
          <oxd-grid :cols="3" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.currency"
                type="select"
                :label="$t('general.currency')"
                :options="currencies"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-divider />
        <oxd-form-actions>
          <required-text />
          <oxd-button
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
    <add-customer-modal
      v-if="showCustomerModal"
      @close="onCustomerModalClose"
    ></add-customer-modal>
  </div>
</template>

<script>
import {
  required,
  validSelection,
  validDateFormat,
  startDateShouldBeBeforeEndDate,
  endDateShouldBeAfterStartDate,
  shouldNotExceedCharLength,
} from '@ohrm/core/util/validation/rules';
import {APIService} from '@/core/util/services/api.service';
import {navigate} from '@ohrm/core/util/helper/navigation';
import {promiseDebounce, OxdSwitchInput} from '@ohrm/oxd';
import AddCustomerModal from '@/orangehrmTimePlugin/components/AddCustomerModal.vue';
import CustomerAutocomplete from '@/orangehrmTimePlugin/components/CustomerAutocomplete.vue';
import useDateFormat from '@/core/util/composable/useDateFormat';
import ProjectAdminAutocomplete from '@/orangehrmTimePlugin/components/ProjectAdminAutocomplete.vue';
import EmployeeAutocomplete from '@/core/components/inputs/EmployeeAutocomplete';

const defaultProjectModel = {
  name: null,
  customer: null,
  description: null,
  attendanceRequired: true,
  budgetRequired: true,
  agreementSigned: true,
  projectAdminEmpNumbers: [],
  fromDate: null,
  toDate: null,
  accountManager: null,
  currency: null,
  status: true,
};

export default {
  name: 'ProjectSave',
  components: {
    'add-customer-modal': AddCustomerModal,
    'customer-autocomplete': CustomerAutocomplete,
    'project-admin-autocomplete': ProjectAdminAutocomplete,
    'employee-autocomplete': EmployeeAutocomplete,
    'oxd-switch-input': OxdSwitchInput,
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/time/projects',
    );
    const {userDateFormat} = useDateFormat();

    http.setIgnorePath('/api/v2/time/validation/project-name');
    return {
      userDateFormat,
      http,
    };
  },
  data() {
    return {
      isLoading: false,
      showCustomerModal: false,
      projectAdmins: [{value: null}],
      project: {...defaultProjectModel},
      projectId: null,
      currencies: [],
      rules: {
        name: [
          required,
          shouldNotExceedCharLength(50),
          promiseDebounce(this.validateProjectName, 500),
        ],
        description: [shouldNotExceedCharLength(255)],
        customer: [required, validSelection],
        projectAdmin: [
          validSelection,
          (value) => {
            return this.projectAdmins.filter(
              ({value: admin}) => admin && admin.id === value?.id,
            ).length < 2
              ? true
              : this.$t('general.already_exists');
          },
        ],
        fromDate: [
          validDateFormat(this.userDateFormat),
          startDateShouldBeBeforeEndDate(
            () => this.project.toDate,
            this.$t('general.from_date_should_be_before_to_date'),
            {allowSameDate: true},
          ),
        ],
        toDate: [
          validDateFormat(this.userDateFormat),
          endDateShouldBeAfterStartDate(
            () => this.project.fromDate,
            this.$t('general.to_date_should_be_after_from_date'),
            {allowSameDate: true},
          ),
        ],
        accountManager: [validSelection],
      },
    };
  },
  computed: {
    totalDuration() {
      if (!this.project.fromDate || !this.project.toDate) return null; // Ensure both dates exist

      const fromDate = new Date(this.project.fromDate);
      const toDate = new Date(this.project.toDate);

      if (isNaN(fromDate) || isNaN(toDate)) return null; // Handle invalid dates

      const durationInMilliseconds = toDate - fromDate;
      return Math.ceil(durationInMilliseconds / (1000 * 60 * 60 * 24)); // Convert ms to days
    },
    totalWorkingDays() {
      if (!this.project.fromDate || !this.project.toDate) return null;

      let fromDate = new Date(this.project.fromDate);
      let toDate = new Date(this.project.toDate);

      if (isNaN(fromDate) || isNaN(toDate)) return null; // Handle invalid dates

      let count = 0;

      while (fromDate <= toDate) {
        const dayOfWeek = fromDate.getDay(); // 0 = Sunday, 6 = Saturday
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          count++; // Only count weekdays (Monday to Friday)
        }
        fromDate.setDate(fromDate.getDate() + 1); // Move to next day
      }

      return count;
    },
  },
  beforeMount() {
    this.http
      .request({
        method: 'GET',
        url: `/api/v2/admin/pay-grades/1/currencies/allowed`,
        params: {
          limit: 0,
        },
      })
      .then((response) => {
        const {data} = response.data;

        // Move the currencies with specific codes (51, 64, 151) to the top
        const topCodes = [51, 67, 151];
        const topCurrencies = data.filter((item) =>
          topCodes.includes(item.code),
        );
        const otherCurrencies = data.filter(
          (item) => !topCodes.includes(item.code),
        );

        // Concatenate the top currencies followed by the other currencies
        this.currencies = [...topCurrencies, ...otherCurrencies].map((item) => {
          return {
            id: item.id,
            label: item.id + ' - ' + item.name,
          };
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onClickAddCustomer() {
      this.showCustomerModal = true;
    },
    onCustomerModalClose(data) {
      if (data !== undefined) {
        const {id, name} = data;
        this.project.customer = {
          id,
          label: name,
        };
      }
      this.showCustomerModal = false;
    },
    onAddAnother() {
      if (this.projectAdmins.length < 5) {
        this.projectAdmins.push({value: null});
      }
    },
    onRemoveAdmin(index) {
      this.projectAdmins.splice(index, 1);
    },
    onCancel() {
      navigate('/time/viewProjects');
    },
    onSave() {
      this.isLoading = true;
      this.http
        .create({
          name: this.project.name,
          description: this.project.description,
          attendanceRequired: this.project.attendanceRequired,
          budgetRequired: this.project.budgetRequired,
          agreementSigned: this.project.agreementSigned,
          customerId: this.project.customer.id,
          projectAdminsEmpNumbers: this.projectAdmins
            .map(({value}) => value && value.id)
            .filter(Number),
          fromDate: this.project.fromDate,
          toDate: this.project.toDate,
          accountManager: this.project.accountManager?.id,
          currencyId: this.project.currency?.id,
          status: this.project.status,
        })
        .then((result) => {
          this.projectId = result.data?.data.id;
          return this.$toast.saveSuccess();
        })
        .then(() => {
          navigate('/time/saveProject/{id}', {id: this.projectId});
        });
    },
    validateProjectName(project) {
      return new Promise((resolve) => {
        if (project) {
          this.http
            .request({
              method: 'GET',
              url: `/api/v2/time/validation/project-name`,
              params: {
                projectName: this.project.name.trim(),
                customerId: this.project.customer?.id,
              },
            })
            .then((response) => {
              const {data} = response.data;
              return data.valid === true
                ? resolve(true)
                : resolve(this.$t('general.already_exists'));
            });
        } else {
          resolve(true);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.gsl-hrm-sm-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $oxd-input-control-vertical-padding 0rem;
  &-label {
    font-weight: 700;
    font-size: $oxd-input-control-font-size;
  }
}
</style>
